import React, { ErrorInfo } from 'react'
import { StoreProps } from '@interfaces/StoreState'
import { ErrorBoundary } from 'react-error-boundary'
import { useSelector } from 'react-redux'
import get from 'lodash/get'

export interface GenericErrorBoundary {
  children: React.ReactNode
  fallback: React.ReactNode
}

const GenericErrorBoundary: React.FC<GenericErrorBoundary> = ({ fallback, children }) => {
  const { authorized, user } = useSelector(({ session }: StoreProps) => ({
    authorized: session.authorized,
    user: session.user,
  }))

  const logError = (error: Error, info: ErrorInfo) => {
    console.log('Log sent!')
    const errorDetails = {
      event: 'errorBoundaryCatch',
      errorType: 'jsError',
      errorCognitoUser: get(user, 'username'),
      errorSFuser: authorized,
      errorStacktrace: info.componentStack,
      errorAdditionalErrorInformation: error.message,
    }

    // @ts-ignore
    if (window && window.dataLayer) {
      // @ts-ignore
      window.dataLayer.push(errorDetails)
    }
  }

  return (
    <ErrorBoundary fallback={<>{fallback}</>} onError={logError}>
      {children}
    </ErrorBoundary>
  )
}

export default GenericErrorBoundary
